<template>
  <div class="header-top-area-cover">
    <div v-if="showTips" class="theme-globalnav-tips">
      <div class="theme-globanav-tips-wrapper cy-common-wrapper">
        <div
          style="position: relative; width: 100%; text-align: center"
          class="swiper toptip-swiper"
        >
          <div class="swiper-wrapper">
            <div
              v-for="(tip, index) in topTipsArr"
              :key="index"
              class="swiper-slide swiper-item"
            >
              <img :src="tip.svgIconUrl" />
              {{ tip.tipsText }}
            </div>
          </div>
          <div v-on:click="closeTips" class="tips-close">
            <cy-icon type="close"></cy-icon>
          </div>
        </div>
      </div>
    </div>
    <div class="theme-globalnav-wrapper cy-common-wrapper scroll-up">
      <span class="m-menu-cover cy-pc-hide" @click="toggleMMenu">
        <svg
          class="mo_show"
          width="35px"
          height="35px"
          viewBox="0 0 35 35"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g
            id="LEMMO1.2.0"
            stroke="currentStyle"
            stroke-width="1"
            fill="currentStyle"
            fill-rule="evenodd"
          >
            <g
              id="1.2.0首页优化"
              transform="translate(-334.000000, -128.000000)"
              fill="currentStyle"
            >
              <g id="编组-3" transform="translate(16.000000, 128.000000)">
                <g id="menu" transform="translate(318.000000, 0.000000)">
                  <path
                    d="M14.75,16.5 L25.25,16.5 C25.6642136,16.5 26,16.8357864 26,17.25 C26,17.6642136 25.6642136,18 25.25,18 L14.75,18 C14.3357864,18 14,17.6642136 14,17.25 C14,16.8357864 14.3357864,16.5 14.75,16.5 Z M9.75,10 L25.25,10 C25.6642136,10 26,10.3357864 26,10.75 C26,11.1642136 25.6642136,11.5 25.25,11.5 L9.75,11.5 C9.33578644,11.5 9,11.1642136 9,10.75 C9,10.3357864 9.33578644,10 9.75,10 Z M9.75,23 L25.25,23 C25.6642136,23 26,23.3357864 26,23.75 C26,24.1642136 25.6642136,24.5 25.25,24.5 L9.75,24.5 C9.33578644,24.5 9,24.1642136 9,23.75 C9,23.3357864 9.33578644,23 9.75,23 Z"
                    id="形状结合"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </span>
      <a class="theme-logo-wrapper m-flexiable-area" :href="rootHref">
        <svg width="100.9372px" height="21.377px" viewBox="0 0 100.9372 21.377" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <title>LEMMO_logo@1x</title>
          <g id="ebike" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <path d="M90.4562,17.676 C81.3932,17.802 81.3932,3.575 90.4572,3.701 C99.5192,3.576 99.5192,17.803 90.4562,17.676 M90.4562,0 C76.4812,0.074 76.4822,21.305 90.4572,21.377 C104.4312,21.303 104.4302,0.072 90.4562,0 M21.3237,0.000516735498 C27.6007,-0.0363 32.6257,5.5347 31.9577,11.7707 L28.2217,11.7707 L14.4267,11.7697 C15.1587,18.1917 24.6047,19.8027 27.4437,14.0427 L31.4647,14.0427 C28.1567,25.2617 10.2957,22.5767 10.6357,10.6887 C10.6357,4.7957 15.4307,0.000516735498 21.3237,0.000516735498 Z M3.787,0.4407 L3.787,18.1917 L12.958,18.1917 L12.958,21.1497 L0,21.1497 L0,0.4407 L3.787,0.4407 Z M28.0517,8.8147 C26.4877,2.1537 16.1617,2.1517 14.5967,8.8147 Z M67.589,13.5767 L60.991,0.4407 L56.494,0.4407 L56.494,21.1497 L56.495,21.1507 L60.282,21.1507 L60.282,6.8607 L66.051,18.1917 L69.039,18.1917 L74.808,6.8607 L74.808,21.1507 L78.595,21.1507 L78.595,0.4407 L74.098,0.4407 L67.589,13.5767 Z M44.191,13.5767 L37.593,0.4407 L33.096,0.4407 L33.096,21.1507 L36.883,21.1507 L36.883,6.8607 L42.652,18.1917 L45.64,18.1917 L51.409,6.8607 L51.409,21.1507 L55.196,21.1507 L55.196,0.4407 L50.699,0.4407 L44.191,13.5767 Z" id="LEMMO_logo" fill="#282828"></path>
          </g>
        </svg>
      </a>
      <div class="theme-menus-wrapper">
        <a
          class="theme-menu-item cy-m-hide"
          style="margin-right: 30px"
          :href="rootHref === '/' ? productLink : rootHref + productLink"
          >{{ PRODUCT }}</a
        >
        <a
          class="theme-menu-item cy-m-hide"
          style="margin-right: 30px"
          :href="rootHref === '/' ? accessoriesLink : rootHref + accessoriesLink"
          >{{ ACCESSORIES }}</a
        >
        <!-- <a
          class="theme-menu-item cy-m-hide"
          style="margin-right: 30px"
          :href="rootHref === '/' ? supportLink : rootHref + supportLink"
          >{{ SUPPORT }}</a
        > -->
        <div class="drop-item" style="position: relative;line-height: 32px;display: flex;align-items: center;">
          <div class="theme-menu-item cy-m-hide drop-item-label" style="margin-right: 30px" @click="switchDrop">
            {{ SERVICE }}
            <span class="arrow-icon" :class="{ 'icon-active': dropActive }">   
              <cy-icon type="arrow" ></cy-icon>
            </span>
          </div>
          <div class="nav-drop-list" :class="{ 'active': dropActive }">
            <a class="content-item" :href="rootHref === '/' ? supportLink : rootHref + supportLink">
              <div class="text">
                <span>{{ SUPPORT }} </span>
              </div>
            </a>
            <a class="content-item" :href="rootHref === '/' ? afterSalesLink : rootHref + afterSalesLink">
              <div class="text">
                <span>{{ AFTERSALES }} </span>
              </div>
            </a>
            <a class="content-item" :href="rootHref === '/' ? mapLink : rootHref + mapLink">
              <div class="text">
                <span>{{ MAP }} </span>
              </div>
            </a>
          </div>
        </div>
        <LanguagPart className="cy-m-hide"></LanguagPart>
        <div class="theme-menu-item m-flexiable-area">
          <a
            style="cursor: pointer; display: inherit"
            :is="!hasCarControl ? 'toggle-link' : ''"
            :aria-controls="!hasCarControl ? 'mini-cart' : ''"
            :aria-expanded="!hasCarControl ? false : ''"
            :aria-label="cartInfo.label || ''"
            data-no-instant
          >
            <svg
              width="24px"
              height="24px"
              viewBox="0 0 24 24"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <g
                id="NEW-step2"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
              >
                <g
                  id="Overview"
                  transform="translate(-1290.500000, -20.500000)"
                  fill="#282828"
                  fill-rule="nonzero"
                >
                  <g id="购物车" transform="translate(1290.500000, 20.500000)">
                    <path
                      d="M11.75,1.5 C14.0132846,1.5 15.8633615,3.26915212 15.9927688,5.49999431 L18.25,5.5 C19.7687831,5.5 21,6.73121694 21,8.25 L21,18.25 C21,19.7687831 19.7687831,21 18.25,21 L5.25,21 C3.73121694,21 2.5,19.7687831 2.5,18.25 L2.5,8.25 C2.5,6.73121694 3.73121694,5.5 5.25,5.5 L7.50723122,5.49999431 C7.63663849,3.26915212 9.48671544,1.5 11.75,1.5 Z M18.25,7 L5.25,7 C4.55964406,7 4,7.55964406 4,8.25 L4,18.25 C4,18.9403559 4.55964406,19.5 5.25,19.5 L18.25,19.5 C18.9403559,19.5 19.5,18.9403559 19.5,18.25 L19.5,8.25 C19.5,7.55964406 18.9403559,7 18.25,7 Z M14.25,11.5 C14.6642136,11.5 15,11.8357864 15,12.25 C15,14.0449254 13.5449254,15.5 11.75,15.5 C9.95507456,15.5 8.5,14.0449254 8.5,12.25 C8.5,11.8357864 8.83578644,11.5 9.25,11.5 C9.66421356,11.5 10,11.8357864 10,12.25 C10,13.2164983 10.7835017,14 11.75,14 C12.7164983,14 13.5,13.2164983 13.5,12.25 C13.5,11.8357864 13.8357864,11.5 14.25,11.5 Z M11.75,3 C10.3154233,3 9.13740948,4.09847614 9.01119332,5.50019359 L14.4888067,5.50019359 C14.3625905,4.09847614 13.1845767,3 11.75,3 Z"
                      id="形状结合"
                    ></path>
                  </g>
                </g>
              </g>
            </svg>
          </a>
        </div>
        <div class="cy-pc-hide header-order-area">
          <div class="btn-ride">
            <div class="btn-txt">{{ testRide }}</div>
            <svg width="8.97716607px" height="9.91492004px" viewBox="0 0 8.97716607 9.91492004" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="页面-2" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square">
                    <g id="H5-overview-门店" transform="translate(-219.500000, -83.292893)" stroke="#282828">
                        <g id="箭头细" transform="translate(220.000000, 84.000000)">
                            <line x1="0" y1="4.28208372" x2="7.5" y2="4.28208372" id="直线-7"></line>
                            <line x1="3.52239829" y1="0" x2="7.76503898" y2="4.24264069" id="直线-7备份"></line>
                            <line x1="3.5274186" y1="8.50070648" x2="7.77005929" y2="4.25806579" id="直线-7备份-2"></line>
                        </g>
                    </g>
                </g>
            </svg>
          </div>
          <a :href="rootHref === '/' ? orderLink : rootHref + orderLink">
            <cy-button class="cy-button--small">
              {{ buyNow }}
            </cy-button>
          </a>
        </div>
      </div>
    </div>
  </div>
  <MenuDrawer :class="{ active: showMMenu }" @close="toggleMMenu"></MenuDrawer>
</template>
<script>
import LanguagPart from "./language.vue";
import MenuDrawer from "./menuDrawer.vue";
// import ModalHelper from '../../api/modalHelper.js'
const clientWidth = document.documentElement.clientWidth;
export default {
  name: "GlobalNavigation",
  components: {
    LanguagPart,
    MenuDrawer,
  },
  data() {
    const {
      locale = "en",
      country,
      language,
      SUPPORT,
      supportLink,
      SERVICE,
      serviceLink,
      PRODUCT,
      productLink,
      ACCESSORIES,
      accessoriesLink,
      AFTERSALES,
      afterSalesLink,
      MAP,
      mapLink,
      topTips,
      cartInfo,
      isIndex = false,
      buyNow,
      testRide,
      orderLink,
      topTipsArr,
      topTipsTime = 3000,
    } = window.globalNavConfig || {};
    return {
      locale,
      country,
      language,
      SUPPORT,
      supportLink,
      serviceLink,
      SERVICE,
      PRODUCT,
      productLink,
      ACCESSORIES,
      accessoriesLink,
      AFTERSALES,
      afterSalesLink,
      MAP,
      mapLink,
      topTips,
      showTips: topTips && topTips.length > 0 && (isIndex && isIndex != 0),
      cartInfo: cartInfo || {},
      showMMenu: false,
      currentTitle: "",
      buyNow,
      testRide,
      orderLink,
      topTipsArr,
      topTipsTime,
      isHideNav: false,
      dropActive: false,
    };
  },
  watch: {
    showMMenu(newValue, oldValue) {
      console.log("hahha....", newValue, oldValue);
      // if (newValue) {
      //     ModalHelper.afterOpen();
      // } else {
      //     ModalHelper.beforeClose();
      // }
      document.documentElement.classList.toggle("lock-all", newValue);
    },
  },
  computed: {
    hasCarControl() {
      return (
        this.cartInfo.cartType === "page" || this.cartInfo.pageType === "cart"
      );
    },
    rootHref() {
      return this.locale === "en" ? "/" : `/${this.locale}`;
    },
  },
  created() {
    this.matchTitleInMobile();
  },
  mounted() {
    this.$nextTick(() => {
      const swiper = new Swiper(".toptip-swiper", {
        direction: "vertical",
        loop: true,
        autoplay: {
          delay: this.topTipsTime,
        },
      });
      window.document.addEventListener("scroll", () => {
        const top =
          document.documentElement.scrollTop || document.body.scrollTop;
        
        if (clientWidth >= 1000) {
          if (top > 60) {
            $(".header-top-area-cover").addClass("hide");
            $("#vue-features-navigation").addClass("sticky");
          } else {
            $(".header-top-area-cover").removeClass("hide");
            $("#vue-features-navigation").removeClass("sticky");
          }
        } else {
          if (top > 56) {
            $(".theme-globalnav-tips").addClass("hide");
          } else {
            $(".theme-globalnav-tips").removeClass("hide");
          }
        }
      });
    });
  },
  methods: {
    closeTips() {
      this.showTips = false;
    },
    toggleMMenu() {
      this.showMMenu = !this.showMMenu;
    },
    matchTitleInMobile() {
      const pathname = window.location.pathname;
      let purePathname = pathname;
      const { sideMenu } = window.globalNavConfig || {};
      console.log( sideMenu, "====?");
      console.log( clientWidth, "2====?");
      console.log( this.isIndex, "3====?");
      console.log( this.topTips, "1====?");
      console.log('window.globalNavConfig', window.globalNavConfig);
      
      console.log(pathname, sideMenu, "222====?");
      this.currentTitle = "";
      sideMenu &&
        sideMenu.length > 0 &&
        sideMenu.forEach((menu) => {
          if (menu.subMenu && menu.subMenu.length > 0) {
            const target = menu.subMenu.find((child) => {
              console.log(
                child.url === purePathname,
                child.url,
                purePathname,
                "====?"
              );
              return child.url === purePathname;
            });
            this.currentTitle = target ? target.title : "";
            if (this.currentTitle) {
              // lemmo ONE 手机端所有的子页面执行这个方法
              this.calHeaderShow();
            }
            return;
          }
          if (menu.url === purePathname) {
            const arr = ["/", "/de", "/fr", "nl"];
            this.currentTitle = arr.includes(purePathname) ? "" : menu.title;
            console.log(this.currentTitle, "currentTitle2====?");
          }
        });
    },
    calHeaderShow() {
      this.ListenScroll(function (direction, scrollTop) {
        // if (direction == "down") {
        //   console.log(direction);
        //   $(".theme-globalnav-wrapper")
        //     .addClass("scroll-down")
        //     .removeClass("scroll-up");
        // } else {
        //   console.log(direction);
        //   $(".theme-globalnav-wrapper")
        //     .addClass("scroll-up")
        //     .removeClass("scroll-down");
        // }
        const screenHeight = window.screen.height;
        if (scrollTop > screenHeight) {
          $(".theme-globalnav-wrapper")
            .addClass("scroll-down")
            .removeClass("scroll-up");
        } else {
          $(".theme-globalnav-wrapper")
            .addClass("scroll-up")
            .removeClass("scroll-down");
        }
      });
    },
    ListenScroll(fn) {
      var $window = $(window),
        beforeScrollTop = $window.scrollTop(),
        fn = fn || function () {};

      $window.scroll(function () {
        var afterScrollTop = $window.scrollTop(),
          delta = afterScrollTop - beforeScrollTop;
        if (delta === 0) return false;
        fn(delta > 0 ? "down" : "up", afterScrollTop);
        beforeScrollTop = afterScrollTop;
      });
    },
    testRideClick() {
        let actionSheetDom = document.getElementById('shopify-section-action-sheet')
        actionSheetDom.querySelector('.action-sheet_overlay').style.opacity = '0.5'
        actionSheetDom.querySelector('.action-sheet_overlay').style.visibility = 'visible'
        actionSheetDom.querySelector('.action-sheet').style.visibility = 'visible'
    },
    switchDrop() {
      this.dropActive = !this.dropActive;
    }
  },
};
</script>

<style lang="scss">
.drop-item-label {
  cursor: pointer;
}
.nav-drop-list {
    visibility: hidden;
    position: absolute;
    top: 45px;
    left: -35px;
    width: 140px;
    background: #fff;
    border-radius: 1px;
    transition: all .3s cubic-bezier(.4, 0, .2, 1);
    transform: translateY(-15px);
    min-width: 140px;
    opacity: 0;
    color: red;
    overflow: hidden;
    box-shadow: 0px 5px 10px 0px rgba(0,0,0,0.05);;
    z-index: 999;

    &.active {
        visibility: visible;
        transform: none;
        background: #FFFFFF;
        opacity: 1;
    }

    .arrow-icon {
        transition: transform .3s cubic-bezier(.4, 0, .2, 1);
        transform: rotate(0deg);

        &.icon-active {
            transform: rotate(-180deg);
        }
    }
    .content-item {
        &:hover {
            background-color: #FAFAF6;

            .text {
                .switch {
                    text-decoration: none !important;
                }
            }
        }
        &:last-child.text:after {display: none;}

        .text {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 12px 20px;
          cursor: pointer;
          width: 100%;
          font-size: 14px;
          font-weight: 600;
          color: #282828;
          
          &:after {
            position: absolute;
            left: 20px;
            right: 20px;
            bottom: 0;
            height: 1px;
            background: #eee;
            content: '';
          }

          .switch {
              font-size: 14px;
              // font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #7AAC64;
              line-height: 20px;
              text-decoration: underline;
              text-underline-offset: 4px;
          }

          .content-item-icon {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 20px;
              height: 20px;
              border-radius: 10px;
              overflow: hidden;
              // background-image: url(//cdn.shopify.com/static/images/flags/de.svg?crop=center&height=25&width=25);
              background-repeat: no-repeat;
              background-size: cover;
          }

          .checkPart {
              position: relative;
              border-radius: 50%;
              width: 20px;
              height: 20px;
              background: #FAFAF6;
              border: 2px solid #CCCCCC;
              margin-right: 10px;
              appearance: none;

              &.checked {
                  display: inline-block;
                  -webkit-appearance: none;
                  background-color: #FAFAF6;
                  position: relative;
                  border: 2px solid #3B4B31;
                  border-radius: 50%;
                  outline: none;
                  cursor: pointer;

                  &:after {
                      position: absolute;
                      content: '';
                      left: 50%;
                      top: 50%;
                      transform: translate(-50%, -50%);
                      width: 16px;
                      height: 16px;
                      border-radius: 50%;
                      background-color: #BDFBA2;
                      font-size: 12px;
                      text-align: center;
                      line-height: 16px;
                      font-weight: 600;
                      background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTZweCIgaGVpZ2h0PSIxNnB4IiB2aWV3Qm94PSIwIDAgMTYgMTYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+6Lev5b6EQDF4PC90aXRsZT4KICAgIDxnIGlkPSJzdGVwMumHjeaehCIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IuivreiogOmAieaLqeWFpeWPoyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTExMjIuMzM1Nzg1LCAtMTkyLjAwMDAwMCkiIGZpbGw9IiMzQjRCMzEiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgICAgIDxnIGlkPSLnvJbnu4QtNiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTEyMi4zMzU3ODUsIDE5Mi4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMi42MzIxMjM2LDYuMTkzNzkwNzYgTDcuOTg1Mzk4MzYsMTAuODQwNTE2IEM3Ljc3Mjc1MzA1LDExLjA1MzE2MTMgNy40MjgyNjc2NSwxMS4wNTMxNjEzIDcuMjE1NjIyMzQsMTAuODQwNTE2IEw0LjAzOTU1MjAzLDcuNjY0NDQ1NyBDMy45ODY4MTU5OSw3LjYxMTcwOTY3IDMuOTg2ODE1OTksNy41MjQ5NTAzOCA0LjAzOTU1MjAzLDcuNDcyMjE0MzUgTDUuMDAxNTU5NCw2LjUxMDIwNjk3IEM1LjA1NDI5NTQ0LDYuNDU3NDcwOTQgNS4xNDEwNTQ3Miw2LjQ1NzQ3MDk0IDUuMTkzNzkwNzYsNi41MTAyMDY5NyBMNy41NTE2MDE5Myw4Ljg2ODAxODE1IEM3LjU3Nzk2OTk1LDguODk0Mzg2MTYgNy42MjEzNDk1OSw4Ljg5NDM4NjE2IDcuNjQ3NzE3NjEsOC44NjgwMTgxNSBMMTEuNDc3MDM0Myw1LjAzOTU1MjAzIEMxMS41Mjk3NzAzLDQuOTg2ODE1OTkgMTEuNjE2NTI5Niw0Ljk4NjgxNTk5IDExLjY2OTI2NTcsNS4wMzk1NTIwMyBMMTIuNjMxMjczLDYuMDAxNTU5NCBDMTIuNjg0ODU5Nyw2LjA1NDI5NTQ0IDEyLjY4NDg1OTcsNi4xNDEwNTQ3MiAxMi42MzIxMjM2LDYuMTkzNzkwNzYgWiIgaWQ9Iui3r+W+hCI+PC9wYXRoPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=);
                  }
              }
          }
        }
    }
}</style>